import React, { useEffect, useState } from 'react';
import axios from 'axios';
import cl from './Modal.module.css';

// Оплата доступа центра картой.
//
// Эквайринг привязан к Майнкрафтии, но аккаунт у владельца центра общий:
// тем же токеном он ходит и сюда, и в школу. Поэтому отдельный SSO-тикет не
// нужен — запрашиваем ссылку оплаты напрямую у платёжного сервиса, а Т-Банк
// уводит человека на свою страницу.
//
// Доступ выдаётся по вебхуку банка автоматически: подтверждать оплату
// руками, как по счёту, здесь не требуется.

const PAYMENTS = 'https://minecraftia-school.ru/api/v2/payments';

const bearer = () => {
    const t = localStorage.getItem('Authorization') || '';
    return t.toLowerCase().startsWith('bearer ') ? t : `Bearer ${t}`;
};

export default function PayModal({ onClose }) {
    const [tariffs, setTariffs] = useState([]);
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(true);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const { data } = await axios.get(`${PAYMENTS}/b2b/tariffs`,
                    { headers: { Authorization: bearer() } });
                if (!alive) return;
                setTariffs(data || []);
                // Годовой тариф выгоднее — предлагаем его первым.
                const year = (data || []).find((t) => t.days >= 365);
                setCode((year || (data || [])[0])?.code || '');
            } catch (e) {
                if (alive) setErr('Не удалось загрузить тарифы');
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, []);

    async function submit(e) {
        e.preventDefault();
        if (!code) return;
        setBusy(true);
        setErr('');
        try {
            const { data } = await axios.post(`${PAYMENTS}/b2b/checkout`, {
                package_code: code,
                success_url: 'https://startklass.ru/cabinet?paid=1',
                fail_url: 'https://startklass.ru/cabinet?paid=0',
            }, { headers: { Authorization: bearer() } });

            if (data?.payment_url) {
                window.location.href = data.payment_url;
                return;
            }
            setErr('Банк не вернул ссылку на оплату');
        } catch (e2) {
            setErr(e2?.response?.data?.detail
                || e2?.response?.data?.message
                || 'Не удалось начать оплату');
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className={cl.backdrop} onClick={onClose}>
            <div className={cl.modal} onClick={(e) => e.stopPropagation()}>
                <button className={cl.close} onClick={onClose} aria-label="Закрыть">×</button>

                <form onSubmit={submit}>
                    <h2 className={cl.title}>Оплата картой</h2>
                    <p className={cl.lead}>
                        Доступ откроется сразу после оплаты. Если для бухгалтерии
                        нужен счёт — закройте это окно и нажмите «Заказать счёт».
                    </p>

                    {err && <div className={cl.err}>{err}</div>}
                    {loading && <p className={cl.lead}>Загружаем тарифы…</p>}

                    <div className={cl.plans}>
                        {tariffs.map((t) => {
                            const checked = code === t.code;
                            return (
                                <label key={t.code}
                                    className={[cl.planRow, checked && cl.planChecked]
                                        .filter(Boolean).join(' ')}>
                                    <input type="radio" name="tariff" value={t.code}
                                        checked={checked}
                                        onChange={() => setCode(t.code)}/>
                                    <span className={cl.planMain}>
                                        <span className={cl.planName}>
                                            {t.days >= 365 ? 'Учебный год' : 'Месяц'}
                                        </span>
                                        <span className={cl.planSub}>{t.title}</span>
                                    </span>
                                    <span className={cl.planPrice}>
                                        {t.price_rub.toLocaleString('ru-RU')} ₽
                                    </span>
                                </label>
                            );
                        })}
                    </div>

                    <button type="submit" className={cl.btnPrimary} disabled={busy || !code}>
                        {busy ? 'Готовим оплату…' : 'Перейти к оплате'}
                    </button>
                </form>
            </div>
        </div>
    );
}
